module.exports = {"ACTIVE":"Active","INACTIVE":"Inactive","ARCHIVED":"Archived","DISABLED":"Disabled"}